import { Values } from '../values.class'

/**
 * @file Defines the {@link AutospinValues} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling autospin values
  * @extends Values
  */
  export class AutospinValues extends Values {

    /** Initialize autospin values */
    constructor() {
        super() //Call parent constructor
    }

    /**
     * Initialise autospin values
     * @param {string[]} v_ - Array of possible autospin values
     */
    init(v_) {

        this._values = v_  //Stores values
        this._index  = 1   //Store index

    }
      
   }